import { Link } from "react-router-dom";

import logo from "@/assets/logo.webp";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="container mx-auto px-4 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <img src={logo} alt="GatorNotes official logo" width={32} height={32} loading="lazy" decoding="async" className="h-8 w-8" />
              <span className="font-display text-lg font-bold text-foreground">GatorNotes</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Transform your study notes into an interactive AI-powered learning experience.
            </p>
          </div>
          <div>
            <h2 className="mb-3 font-display font-semibold text-foreground text-base">Platform</h2>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <Link to="/browse" className="hover:text-foreground transition-colors">Browse Notes</Link>
              <Link to="/notes" className="hover:text-foreground transition-colors">Notes by Subject</Link>
              <Link to="/sell" className="hover:text-foreground transition-colors">Sell Notes</Link>
              <Link to="/ai-tools" className="hover:text-foreground transition-colors">AI Tools</Link>
            </div>
          </div>
          <div>
            <h2 className="mb-3 font-display font-semibold text-foreground text-base">Resources</h2>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <Link to="/help" className="hover:text-foreground transition-colors">Help Center</Link>
              <Link to="/blog" className="hover:text-foreground transition-colors">Study Guides</Link>
              <Link to="/notes" className="hover:text-foreground transition-colors">Notes by Level</Link>
              <Link to="/connect" className="hover:text-foreground transition-colors">Connect to AI</Link>
            </div>
          </div>
          <div>
            <h2 className="mb-3 font-display font-semibold text-foreground text-base">Legal</h2>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
              <Link to="/cookies" className="hover:text-foreground transition-colors">Cookie Policy</Link>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-border pt-6 text-center text-sm text-muted-foreground">
          © 2026 GatorNotes. All rights reserved.
        </div>
      </div>
    </footer>
  );
}